export default __webpack_public_path__ + "static/media/CLYBYMATTHEW_20221125PV_0046_MR1_6214_tn.eb90c08e.jpg";